import React from "react";
import { RadioGroup } from "@telia/teddy";
import TEXT from "../../../text-consts";

interface Props {
    checked: boolean;
    setValue: (value: boolean) => void;
}

const ProductUserController = ({ setValue, checked }: Props) => {
    return (
        <RadioGroup
            className="customer-info__radio-group"
            defaultValue={checked ? "meg-selv" : "noen-andre"}
            onValueChange={(value) => {
                const isSomeoneElse = value === "noen-andre";
                setValue(isSomeoneElse);
            }}
        >
            <RadioGroup.GroupLabel>{TEXT.ADD_MEMBER.RADIO_GROUP.LABEL}</RadioGroup.GroupLabel>
            <RadioGroup.Item className="customer-info__radio-group-item">
                <RadioGroup.Trigger value="meg-selv" />
                <RadioGroup.Label>{TEXT.ADD_MEMBER.RADIO_GROUP.MEG_SELV}</RadioGroup.Label>
            </RadioGroup.Item>
            <RadioGroup.Item className="customer-info__radio-group-item">
                <RadioGroup.Trigger value="noen-andre" />
                <RadioGroup.Label>{TEXT.ADD_MEMBER.RADIO_GROUP.NOEN_ANDRE}</RadioGroup.Label>
            </RadioGroup.Item>
        </RadioGroup>
    );
};

export default ProductUserController;
